<h2 mat-dialog-title>Order Detail</h2>
<mat-dialog-content class="mat-typography">

  <dx-data-grid 
          id="gridContainer96" 
          [dataSource]="salesOrderData"  
          [wordWrapEnabled]="false"
          #grid
          [hoverStateEnabled]="true"
          [columnAutoWidth]="true"
          [allowColumnResizing]="true"
          [columnResizingMode]="'widget'"
          [allowColumnReordering]="true"
          [showBorders]="true">
        <dxo-load-panel [enabled]="true"></dxo-load-panel>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-paging [pageSize]="15"></dxo-paging>
        <dxo-export [enabled]="true" fileName="AllProductionInquiry" [allowExportSelectedData]="false"></dxo-export>
        <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>
        <dxo-pager [showPageSizeSelector]="false" [allowedPageSizes]="[15, 30, 40]" [showInfo]="true"></dxo-pager>
        <dxi-column dataField="customerName" [fixed]="true" caption="Customer Name" cssClass="text-left" [width]="200"></dxi-column>
        <dxi-column dataField="salesOrderNo" [fixed]="true" caption="SO #" cssClass="text-center" [width]="50"></dxi-column>
        <dxi-column dataField="baseSalesOrderId" [visible]="false" [fixed]="true" caption="Ref.SO #" cssClass="text-center" [width]="100"></dxi-column>
        <dxi-column dataField="salesOrderTypeName" [fixed]="true" caption="Type" cssClass="text-left" [width]="80"></dxi-column>
        <dxi-column dataField="salesOrderDate" [fixed]="true"  caption="Order Date" cssClass="text-left" [width]="80" [allowFiltering]="false"></dxi-column>
        <dxi-column dataField="itemName" [fixed]="true" caption="Catalog" cssClass="text-left" [width]="200"></dxi-column>
        <dxi-column dataField="currentStatus" caption="Status" cssClass="text-left" cellTemplate="currentStatusTemplate"></dxi-column>
        <dxi-column dataField="side" caption="Side" cssClass="text-center"></dxi-column>
        <dxi-column dataField="size" caption="Size" cssClass="text-center"></dxi-column>
        <dxi-column dataField="holdStatus" caption="Hold" cssClass="text-center" [width]="100" cellTemplate="holdTemplate"></dxi-column>
        <dxi-column dataField="sph" caption="SPH" cssClass="text-center" cellTemplate="sphTemplate"></dxi-column>
        <dxi-column dataField="cyl" caption="CYL" cssClass="text-center" cellTemplate="cylTemplate"></dxi-column>
        <dxi-column dataField="axis" caption="AXIS" cssClass="text-center" cellTemplate="axisTemplate"></dxi-column>
        <dxi-column dataField="add" caption="ADD" cssClass="text-center" cellTemplate="addTemplate"></dxi-column>
        <dxi-column dataField="services" caption="Services" cssClass="text-center" ></dxi-column>
        <dxi-column dataField="totalAmount" caption="Amount" cssClass="text-right" [width]="100" ></dxi-column>
        <dxi-column dataField="unitPrice" caption="Price" cssClass="text-center" ></dxi-column>
        <dxi-column dataField="oQty" caption="O. QTY" cssClass="text-center" [width]="100" ></dxi-column>
        <dxi-column dataField="iQty" caption="I. QTY" cssClass="text-center" [width]="100" ></dxi-column>
        <dxi-column dataField="invoiceId" caption="Invoice #" cssClass="text-center" ></dxi-column>
        <dxi-column dataField="salesOrderComplainId" caption="Complaint #" cssClass="text-center" ></dxi-column>
        <dxi-column dataField="salesReturnId" caption="Return #" cssClass="text-center" ></dxi-column>
        <dxi-column dataField="reasonRemarks" caption="Store Remarks" cssClass="text-left" ></dxi-column>
        <dxi-column dataField="createdBy" caption="Created By" cssClass="text-left" ></dxi-column>
        <dxi-column dataField="poNumber" caption="PO #" cssClass="text-left" ></dxi-column>
        <dxi-column dataField="customerCityName" caption="Customer City" cssClass="text-left" ></dxi-column>
        <dxi-column dataField="companyBranchName" caption="Branch Name" cssClass="text-left"></dxi-column>
        <dxi-column dataField="soackTime" caption="Ack. Time" cssClass="text-left"></dxi-column>
        <dxi-column dataField="soIssueTime" caption="Issue Time" cssClass="text-left" ></dxi-column>
        <dxi-column dataField="branchACKTime" caption="Branch Ack. Time" cssClass="text-left" ></dxi-column>
        <dxi-column dataField="coatingBrandName" caption="Coating" cssClass="text-left" ></dxi-column>
        <dxi-column dataField="plantName" caption="Plant Name" cssClass="text-left" ></dxi-column>
        <dxi-column dataField="productionOutTime" caption="Production Out Time" cssClass="text-left" ></dxi-column>
      <div *dxTemplate="let data of 'currentStatusTemplate'">
        <div [ngStyle]="{'color': data.data.color}"><strong> {{data.data.currentStatus}}</strong></div>
      </div>
      
        <div class="employee dx-row" *dxTemplate="let d of 'holdTemplate'">
          <div class="main-row">
            <span>{{d.data.holdStatus ? 'Yes' : 'No'}}</span>
          </div>
        </div>
        <div class="employee dx-row" *dxTemplate="let d of 'sphTemplate'" >
            <div class="main-row">
                <div class="text-center">
                    <div *ngIf="d.data.sph && d.data.sph || d.data.sph == 0 && d.data.sph">
                        <mat-chip>{{d.data.sph | number : '1.2-2' }}</mat-chip>
                    </div>
                </div>
            </div>
        </div>
        <div class="employee dx-row" *dxTemplate="let d of 'cylTemplate'" >
          <div class="main-row">
              <div class="text-center">
                  <div *ngIf="d.data.cyl && d.data.cyl || d.data.cyl == 0 && d.data.cyl">
                      <mat-chip>{{d.data.cyl | number : '1.2-2' }}</mat-chip> 
                  </div>
              </div>
          </div>
        </div>
        <div class="employee dx-row" *dxTemplate="let d of 'axisTemplate'" >
          <div class="main-row">
              <div class="text-center">
                  <div *ngIf="d.data.axis && d.data.axis || d.data.axis == 0 && d.data.axis">
                      <mat-chip>{{d.data.axis }}</mat-chip> 
                  </div>
              </div>
          </div>
        </div>
        <div class="employee dx-row" *dxTemplate="let d of 'addTemplate'" >
          <div class="main-row">
              <div class="text-center">
                  <div *ngIf="d.data.add && d.data.add || d.data.add == 0 && d.data.add">
                      <mat-chip>{{d.data.add | number : '1.2-2' }}</mat-chip> 
                  </div>
              </div>
          </div>
        </div>
        <dxo-summary [recalculateWhileEditing]="true">
          <dxi-total-item
            column="customerName"
            alignment="right"
            [customizeText]="customizeTextOrders"
            summaryType="sum">
          </dxi-total-item>
          <dxi-total-item
            column="salesOrderNo"
            alignment="center"
            [customizeText]="customizeTotal"
            summaryType="count">
          </dxi-total-item>
          <dxi-total-item
              column="services"
              alignment="right"
              [customizeText]="customizeText"
              summaryType="sum">
          </dxi-total-item>
          <dxi-total-item
              column="totalAmount"
              alignment="center"
              [customizeText]="customizeTotal"
              summaryType="sum">
          </dxi-total-item>
          <dxi-total-item
            column="oQty"
            alignment="center"
            [customizeText]="customizeTotal"
            summaryType="sum">
          </dxi-total-item>
          <dxi-total-item
            column="iQty"
            alignment="center"
            [customizeText]="customizeTotal"
            summaryType="sum">
          </dxi-total-item>
        </dxo-summary>
      </dx-data-grid>


</mat-dialog-content>
<mat-dialog-actions align="end">
  <button  class="mat-raised-button" mat-dialog-close>Close</button>
</mat-dialog-actions>